/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from 'axios'

// 🔴 **`Bearer ` 를 붙이지 않는다.** 서버의 auth.verify 는 접두어를 벗겨 주지만
//    `mem_reporter_token` 의 저장된 토큰과 **문자열을 비교하는 곳들**은 그렇지 않다.
//    새로고침 직후에만 여기서 접두어가 붙어 형식이 갈렸고, 한 번 어긋나면 DB 의
//    토큰이 **영영 갱신되지 않았다**(dev 에서 재현 확인, 2026-09-27).
//    라우터 가드(router.js)와 세션 하트비트(utils/session.js)는 원래 접두어가 없다.
const enhanceAccessToeken = () => {
  const {accessToken} = localStorage
  if (!accessToken) return
  axios.defaults.headers.common['token'] = accessToken;
}
const enhanceBannerToeken = () => {
  const {bannertoken} = localStorage
  // console.log(accessToken);
  if (!bannertoken) return
  axios.defaults.headers.common['bannertoken'] = `Bearer ${bannertoken}`;
}
enhanceAccessToeken()
enhanceBannerToeken()

const actions = {
    LOGIN ({commit}, {id, password}) {
      return axios.post(`/api/login`, {id, password})
        .then(({data}) => {
          commit('LOGIN', data.token);
          commit('USERSTATE', data.user);
          // console.log(data.token);
          axios.defaults.headers.common['token'] = data.token;
        })
    },
    LOGOUT ({commit}) {
      axios.defaults.headers.common['token'] = undefined;
      commit('LOGOUT');
    },
    bannerManagerLOGIN ({commit}, {id, password}) {
      return axios.post(`/api/bannerManager/login`, {id, password})
        .then(({data}) => {
          commit('bannerManagerLOGIN', data.token);
          // console.log(data.token);
          axios.defaults.headers.common['bannertoken'] = `Bearer ${data.token}`;
        })
    },
    EditWriterList ({commit}, {writer}){
      commit('EditWriterList', writer);
    },
    SetWriterAll ({commit}, {writerAll}){
      commit('SetWriterAll', writerAll);
    },
    SetHrUser ({commit}, {hrUser}){
      commit('SetHrUser', hrUser);
    },
    setSeriesState({commit}, {seriesArray}){
      // console.log(seriesArray);
      commit('SEREIESEDIT', seriesArray);
    },

    // ////////////////////////////////////////////
    // SIDEBAR & UI UX
    // ////////////////////////////////////////////

    updateSidebarWidth({ commit }, width) {
        commit('UPDATE_SIDEBAR_WIDTH', width);
    },
    updateI18nLocale({ commit }, locale) {
        commit('UPDATE_I18N_LOCALE', locale);
    },
    toggleContentOverlay({ commit }) {
        commit('TOGGLE_CONTENT_OVERLAY');
    },
    updateTheme({ commit }, val) {
        commit('UPDATE_THEME', val);
    },


    // ////////////////////////////////////////////
    // COMPONENT
    // ////////////////////////////////////////////

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
        commit('UPDATE_STARRED_PAGE', payload)
    },

    //  The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
        commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({ commit }, list) {
        commit('ARRANGE_STARRED_PAGES_MORE', list)
    },
}

export default actions
